
import React,{forwardRef,useEffect,useRef,useState} from 'react'
import mstyles from '../modules.module.css'
import {getContentPath} from  'system/AssetManager'

import LoaderWheel from 'system/components/LoaderWheel'
import {ReactComponent as CloseButton} from 'assets/icons/close.svg'
import gsap,{Power2} from 'gsap'
import Globals  from 'system/Globals'

const VideoModule = forwardRef((props, ref)=>{

    const refVid = useRef()
    const refFormat = useRef()
    
    const [bLoaded,setBLoaded] = useState(false)
    const [vidSrc,setVidSrc] = useState(0)
    
    useEffect(()=>{
        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)
        ref.current.style.display='hidden'
        setVidSrc(getContentPath(refFormat.current.file))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    function onLoad(){
        setBLoaded(true)
        ref.current.style.visibility='visible'
        gsap.from(ref.current,{duration:0.5,opacity:0,scale:0.5, ease:Power2.easeInOut,onComplete:()=>{
        }})
    }

    function onClickClose(evt){props.closeModule()}

    return (
        <div className={`fullscreen fcenter` } ref={ref}>
        <div className={`fullscreen fcenter`}>
            
            {!bLoaded && (
                <LoaderWheel></LoaderWheel>
            )
            }

            <video style={{width:"100%",height:"100%",objectFit:props.fit?props.fit:'cover'}}  ref={refVid} loop  muted playsInline autoPlay src={vidSrc} type="video/mp4" controls onLoadedMetadata={onLoad}>
                <source src={vidSrc} type="video/mp4"></source>
            </video>

        </div>
            <div className={`${mstyles.closeBtnContainer}`}>
              
                <div className={`${mstyles.btn}`} onClick={onClickClose}>
                    <CloseButton></CloseButton>
                </div>
            </div>

        </div>
    )

})

export default VideoModule
